var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.531 0.531C9.189 0.189 8.73 0 8.253 0H1.8C0.81 0 0 0.81 0 1.8V16.2C0 17.19 0.801 18 1.791 18H12.6C13.59 18 14.4 17.19 14.4 16.2V6.147C14.4 5.67 14.211 5.211 13.869 4.878L9.531 0.531ZM9.9 14.4H4.5C4.005 14.4 3.6 13.995 3.6 13.5C3.6 13.005 4.005 12.6 4.5 12.6H9.9C10.395 12.6 10.8 13.005 10.8 13.5C10.8 13.995 10.395 14.4 9.9 14.4ZM9.9 10.8H4.5C4.005 10.8 3.6 10.395 3.6 9.9C3.6 9.405 4.005 9 4.5 9H9.9C10.395 9 10.8 9.405 10.8 9.9C10.8 10.395 10.395 10.8 9.9 10.8ZM8.1 5.4V1.35L13.05 6.3H9C8.505 6.3 8.1 5.895 8.1 5.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.7afb52e2.svg";
export { ForwardRef as ReactComponent };